export const hasERPModuleActive = (modules: Set<string>) => modules.has('erp');
